import React from 'react';

import Carousel, { CarouselSlideRenderControlProps } from 'nuka-carousel';
import { CaretLeft, CaretRight } from 'phosphor-react';

import s from '../MagicImportStatusModal.module.css';
import { FEATURES_CAROUSEL_SLIDES } from './constants';
import { SlideScene } from './SlideScene';

export const FeaturesCarousel = () => {
  /**
   * Handles navigation to the previous slide with circular behavior
   * When at the first slide, wraps around to the last slide
   */
  const handlePreviousSlide = (props: CarouselSlideRenderControlProps, e: React.MouseEvent) => {
    const desired = (props.currentSlide - 1) % props.slideCount;
    props.goToSlide(desired < 0 ? props.slideCount - 1 : desired);
    e.stopPropagation();
  };

  /**
   * Handles navigation to the next slide with circular behavior
   * When at the last slide, wraps around to the first slide
   */
  const handleNextSlide = (props: CarouselSlideRenderControlProps, e: React.MouseEvent) => {
    const desired = (props.currentSlide + 1) % props.slideCount;
    props.goToSlide(desired);
    e.stopPropagation();
  };

  return (
    <div className={s.sliderWrapper}>
      {/*@ts-ignore*/}
      <Carousel
        slidesToShow={1}
        defaultControlsConfig={{
          containerClassName: s.controlContainer,
        }}
        renderCenterLeftControls={(props) => (
          <button tabIndex={-1} onClick={(e) => handlePreviousSlide(props, e)} className={s.control}>
            <CaretLeft className={s.sliderArrow} />
          </button>
        )}
        renderCenterRightControls={(props) => (
          <button tabIndex={-1} onClick={(e) => handleNextSlide(props, e)} className={s.control}>
            <CaretRight className={s.sliderArrow} />
          </button>
        )}
      >
        {FEATURES_CAROUSEL_SLIDES.map((slideData, index) => (
          <SlideScene key={index} {...slideData} />
        ))}
      </Carousel>
    </div>
  );
};
